import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GetCourseTeachersState {
    teachers: any[];
    isLoading: boolean;
    error: string | null;
}

const initialState: GetCourseTeachersState = {
    teachers: [],
    isLoading: false,
    error: null,
};

const getCourseTeachersSlice = createSlice({
    name: "getCourseTeachers",
    initialState,
    reducers: {
        setCourseTeachersLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setCourseTeachers: (state, action: PayloadAction<any[]>) => {
            state.teachers = action.payload ?? [];
            state.isLoading = false;
            state.error = null;
        },
        setCourseTeachersError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
            state.isLoading = false;
            state.teachers = [];
        },
        resetCourseTeachers: () => initialState,
    },
});

export const {
    setCourseTeachersLoading,
    setCourseTeachers,
    setCourseTeachersError,
    resetCourseTeachers,
} = getCourseTeachersSlice.actions;

export default getCourseTeachersSlice.reducer;
